import React from 'react';
import { Form, Input, Button,Spin,DatePicker, Card,Result,Tabs, message,Modal,Switch } from 'antd';
import axios from 'axios'
import * as serverconfig from '../serverconn'
import { UserOutlined, LockOutlined, LoadingOutlined, MailOutlined,UploadOutlined,DownloadOutlined } from '@ant-design/icons';
import moment from 'moment';
import * as reactstrp from 'reactstrap';
import CurrencyFormat from 'react-currency-format';
import ReactExport from "@ibrahimrahmani/react-export-excel";

var CryptoJS = require("crypto-js");
const { RangePicker } = DatePicker;

const { TabPane } = Tabs;

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;


const FormItem=Form.Item;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

var token= ''
var sacco= ''
var username=''

const dateFormat = 'DD/MM/YYYY';

class SavingsInterestPayOffFormManual extends React.Component {

  state = {
    datarequested:false,
    dateone:moment().format(dateFormat).toString(),
    datetwo:moment().format(dateFormat).toString(),

    datasubmittedsuccessfully:false,
    payofflist:[],
    overalltotalpay:0,
    interestrate:0,
    show_txns:false,
    memberTransactions:[],

    send_email:false,
    send_sms:false,
    deduct_tax:false,
    tax_percentage:0,
    date:moment().format(dateFormat).toString(),



  }

  componentDidMount(){
    if(localStorage.getItem("sacco")){
       sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
       username= CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)

      }else{
       sacco= ''
       username=''
    }
    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }


    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }
  }


  //submit button pressed

  render(){

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )
    }else{
      return (
        <div style={{overflowX:'scroll'}}>
          {
          this.state.datasubmittedsuccessfully===true?
          <Card>
        <Result
        status="success"
        title="Interest awarding task in progress"
        extra={[
          <Button  type='primary' onClick={()=>{window.location.reload(false)}}>Finish</Button>,
        ]}
        />
  </Card>
  :
  <div>
    <Card>

     <h5>Manual interest awarding with dynamic interest rate.  </h5>
        <Form layout="inline">


        <FormItem label="Period of award (range)"
          name='date'
          rules={[
            {
              required: true,
              message: 'Please Select date',
            },
          ]}
        >
            <RangePicker defaultValue={moment()} onChange={(date, dateString) =>{
                this.setState({ dateone: dateString[0]});
                this.setState({ datetwo: dateString[1]});
              }} format={dateFormat} />
        </FormItem>

        <FormItem label="Annual interest rate">
          <Input name="interestrate"  placeholder="Interest rate" value={this.state.interestrate} onChange={(val)=>{this.setState({interestrate:val.target.value})}} />
        </FormItem>

        <FormItem>
            <Button  type="primary" htmlType='button' 
              onClick={(event) =>{
                if (this.state.interestrate<=0){
                  message.error("Please enter rate")
                }  else if (this.state.dateone===""){
                  message.error("Date one missing")
                }else if (this.state.datetwo===""){
                  message.error("Date two missing")
                }else{

                  this.setState({datarequested:true})

                  let form_data = new FormData();
                  form_data.append('dateone', this.state.dateone);
                  form_data.append('datetwo', this.state.datetwo);
                  form_data.append('interestrate', this.state.interestrate);
  
                  form_data.append('sacco', sacco);
                  form_data.append('username', username);
  
                  axios.post(serverconfig.backendserverurl+'/customqueries/computerTransferInterest_manual', form_data, {
                    headers: {
                      'content-type': 'multipart/form-data'
                    }
                  })
                .then(res =>{
                   this.setState({overalltotalpay:res.data.overalltotalpay})
                   this.setState({payofflist:JSON.parse(res.data.payment_list)})
  
                    this.setState({datarequested:false})
                    
                })
                  .catch(error => console.log(error))
                }


              }}>Compute total interest pay</Button>
             </FormItem>



             <FormItem label="Send email?" >
                          <Switch
                              checked={this.state.send_email}
                              onChange={val=>{this.setState({send_email:val})}}
                              checkedChildren="True"
                              unCheckedChildren="False"
                              />
                      </FormItem>


                    <FormItem label="Send sms?" >
                          <Switch
                              checked={this.state.send_sms}
                              onChange={val=>{this.setState({send_sms:val})}}
                              checkedChildren="True"
                              unCheckedChildren="False"
                              />
                      </FormItem>

                  <FormItem label="Deduct tax?" >
                      <Switch
                          checked={this.state.deduct_tax}
                          onChange={val=>{this.setState({deduct_tax:val})}}
                          checkedChildren="True"
                          unCheckedChildren="False"
                          />
                  </FormItem>

                  {
                    this.state.deduct_tax?
                    <FormItem label={<h6 style={{fontWeight:'bold'}}>Tax percentage </h6>}>
                        <Input name="tax_percentage" 
                          placeholder="0"
                           value={this.state.tax_percentage}
                          onChange={(e) =>{
                            this.setState({ tax_percentage: e.target.value})  
                          }
                        } />
                    </FormItem>
                    :
                    null
                  }


        {
          this.state.payofflist.length>0?
          <FormItem>
            <Button  type="primary" htmlType="button" onClick={(event) =>{

                if (this.state.payofflist.length<=0){
                  message.error("Paylist cant be empty")
                }else if (this.state.deduct_tax===true && this.state.tax_percentage===0){
                  message.error("Tax percentage cant be zero")
                }

                else{

                  this.setState({datarequested:true})

                  let form_data = new FormData();
                  form_data.append('sacco', sacco);
                  form_data.append('username', username);
                  form_data.append('payofflist', JSON.stringify(this.state.payofflist));

                  form_data.append('send_email', this.state.send_email);
                  form_data.append('send_sms', this.state.send_sms);
                  form_data.append('deduct_tax', this.state.deduct_tax);
                  form_data.append('tax_percentage', this.state.tax_percentage);

                  form_data.append('dateone', this.state.dateone);
                  form_data.append('datetwo', this.state.datetwo);

                  axios.post(serverconfig.backendserverurl+'/customqueries/mass_transfersavings_interest_tosavings_manual', form_data, {
                    headers: {
                      'content-type': 'multipart/form-data'
                    }
                  })
                .then(res =>{
                  this.setState({datarequested:false})
                  if (res.data.message==="interest awarding task in progress"){
                    this.setState({datasubmittedsuccessfully:true})
                  }
                })
                  .catch(error => console.log(error))

                }

              }}  >Payoff interest</Button>
          </FormItem>
          :
          null
        }


        {
          this.state.payofflist.length>0?
            <ExcelFile filename={"Pisacco - Savings interest transfer to savings report on "+this.state.date}  element={<Button type='primary' icon={<DownloadOutlined/>}>Download (Excel)</Button>}>
              <ExcelSheet data={this.state.payofflist} name={"Savings Interest award report"}>
                  <ExcelColumn label="Name" value="FullName"/>
                  <ExcelColumn label="Account Number" value="AccountNumber"/>
                  <ExcelColumn label="Total pay" value="member_total"/>
              </ExcelSheet>

            {
              this.state.payofflist.map((item)=>{
              return(
                <ExcelSheet data={item.txn_list} name={item.AccountNumber}>
                  <ExcelColumn label="Date" value="date"/>
                  <ExcelColumn label="No of days" value="dayspast"/>
                  <ExcelColumn label="Amount to receive interest" value="receiving_amount"/>
                  <ExcelColumn label="Interest Amount" value="intpay"/>
                  <ExcelColumn label="Desc" value="desc"/>
                </ExcelSheet>
              )
            })

            }
        </ExcelFile>
        :
        null
      }

       </Form>
       <br></br>

    {
                this.state.payofflist.length>0?
                <reactstrp.Table bordered>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Account</th>
                    <th>Total Pay amount</th>
                    <th>Txns</th>

                  </tr>
                </thead>
                <tbody>
                {this.state.payofflist.map(
                  (item)=>(
                    <tr>
                    <td>{item.FullName}</td>
                    <td>{item.AccountNumber}</td>
                    <td>{<CurrencyFormat value={item.member_total} displayType={'text'} thousandSeparator={true}/>}</td>
                    <td><Button type='primary' onClick={()=>{
                                this.setState({memberTransactions:item.txn_list})
                                this.setState({show_txns:true})
                              }}>View</Button>
                     </td>
                    </tr>
                  ))}
                  <tr>
                  <td style={{fontWeight:'bolder'}}>Total</td>
                  <td style={{fontWeight:'bolder'}}></td>
                  <td style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.state.overalltotalpay} displayType={'text'} thousandSeparator={true}/>}</td>
                  </tr>

                 </tbody>
                </reactstrp.Table> 

                :
                null
              }

    </Card>



    <Modal    
              visible={this.state.show_txns}
              title="Savings transactions."
              onCancel={()=>{this.setState({show_txns:false})}}
              footer={[
                <Button key="back" onClick={()=>{this.setState({show_txns:false})}}>
                  Cancel
                </Button>
                ]}
                width={1000}
                >
                  {
                    this.state.memberTransactions.length>0?
                    <reactstrp.Table bordered>
                          <thead>
                            <tr>
                              <th>Date</th>
                              <th>No of days</th>
                              <th>Savings for interest</th>
                              <th>Pay amount</th>
                              <th>Desc</th>
                            </tr>
                          </thead>
                          <tbody>
                          {this.state.memberTransactions.map(
                            (item)=>(
                              <tr key={item.date}>
                              <td>{item.date}</td>
                              <td>{item.dayspast}</td>
                              <td>{<CurrencyFormat value={Number(item.receiving_amount).toFixed(2)} displayType={'text'} thousandSeparator={true}/>}</td>
                              <td>{<CurrencyFormat value={Number(item.intpay).toFixed(2)} displayType={'text'} thousandSeparator={true}/>}</td>
                              <td>{item.desc}</td>

                              </tr>
                            ))}

                        </tbody>
                        
                    </reactstrp.Table> 
                    :
                    null
                  }

            </Modal>
        </div>
      }

   </div>
     );

    }

  }

}


export default SavingsInterestPayOffFormManual;



